export var IdBuilding;
(function (IdBuilding) {
    IdBuilding[IdBuilding["Fence"] = 4] = "Fence";
    IdBuilding[IdBuilding["Acre"] = 7] = "Acre";
    IdBuilding[IdBuilding["FertileAcre"] = 30] = "FertileAcre";
    IdBuilding[IdBuilding["Windmill"] = 8] = "Windmill";
    IdBuilding[IdBuilding["SimpleHouse"] = 16] = "SimpleHouse";
    IdBuilding[IdBuilding["GnomePinwheels"] = 60] = "GnomePinwheels";
    IdBuilding[IdBuilding["FancyHouse"] = 29] = "FancyHouse";
})(IdBuilding || (IdBuilding = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdBuilding.ts
// module id = 172
// module chunks = 3